import { render, staticRenderFns } from "./BugReport.vue?vue&type=template&id=8eebbfee"
import script from "./BugReport.vue?vue&type=script&lang=ts"
export * from "./BugReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports